import React from "react";

import svg from "../../assets/images/icons/close_small.svg";

export const CloseSmallIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Close"}
    />
);
